import './styles/App.scss';
import Content from './Components/Content';

function App() {
  return (
    <div className="App">
     <Content></Content>
    </div>
  );
}

export default App;
